import { HttpParams } from '@angular/common/http';
import { GetElementsValue } from './get-elements.value';

export class GetElementsValueDto {
    page: number;
    limit: number;

    constructor(data: GetElementsValue) {
        this.page = data.page;
        this.limit = data.limit;
    }

    toHttpParams(): HttpParams {
        return new HttpParams().set('page', this.page).set('limit', this.limit);
    }
}
